import React, { useMemo } from 'react';
import { SearchClient } from 'instantsearch.js';
import { Configure, InstantSearch } from 'react-instantsearch';

import { useEventListContext } from '../context/EventListProvider';
import FacetDialog from './FacetDialog';
import EventListResults from './EventListResults';
import DialogToggle from './DialogToggle';

export type EventListProps = {
  searchClient: SearchClient;
  indexName?: string;
};

const EventList = ({
  searchClient,
  indexName = 'dgfp_shared_index'
}: EventListProps) => {
  const { headline, facets, search } = useEventListContext();
  const attributes = (facets || [])?.map((i) => i.attribute);

  const getSearchFilters = () => {
    const today = new Date(new Date().setHours(0, 0, 0, 0));
    const now = Math.floor(today.getTime() / 1000);
    const base = `(end_date_timestamp:>= ${now})`;

    if (search.filters) return `${base} && ${search.filters}`;
    return base;
  };

  const filters = useMemo(() => getSearchFilters(), []);

  return (
    <InstantSearch
      searchClient={searchClient}
      indexName={indexName}
      routing={true}
    >
      <Configure analytics={false} filters={filters} />

      {(facets || headline) && (
        <div className="event-list__header">
          {facets && <DialogToggle includedAttributes={attributes} />}
          {headline && (
            <h2 className="typo-headline-2 font-bold">{headline}</h2>
          )}
        </div>
      )}

      <EventListResults />

      {facets && facets.length > 0 && <FacetDialog />}
    </InstantSearch>
  );
};

export default EventList;
